import { router } from "@inertiajs/react";
import { useContext, useEffect, useState } from "react";
import { AiOutlineThunderbolt } from "react-icons/ai";
import { BiCalendar, BiFile } from "react-icons/bi";
import { BsHouse } from "react-icons/bs";

import SimpleButton from "@/components/Buttons/SimpleButton";
import { CardRow, CardRowActions, CardRowCell, CardRowCells } from "@/components/CardRow";
import BillsInfo from "@/components/Cards/BillsInfo";
import FaqCardComponent from "@/components/Cards/FaqComponent";
import CreateConsumerModal from "@/components/Consumers/CreateConsumerModal";
import Dropdown from "@/components/Dropdown";
import CreateFacilityModal, { FacilityData } from "@/components/Facilities/CreateFacilityModal";
import Footer from "@/components/Footer";
import Pill from "@/components/Pill";
import PowerPlantNameDisplay from "@/components/PowerPlantNameDisplay";
import Typography from "@/components/Typography";
import { AlertContext } from "@/contexts/Alert";
import { dateReferenceFormat, monthYearFormat } from "@/utils/dateFormater";
import { getYearOptions } from "@/utils/getYearOptions";
import moneyFormatter from "@/utils/moneyFormat";
import numberFormatter from "@/utils/numberFormatter";
import { OverdueStatus } from "@/utils/statusFormater";

import {
  AccountTimeDiv,
  BillsDiv,
  BreakDiv,
  ButtonContainer,
  ButtonDiv,
  CenterDiv,
  DatesSecondDiv,
  FiltersContainer,
  FirstDiv,
  HeaderInfo,
  // IconDiv,
  InfoIconDiv,
  // InformationBox,
  InformationBoxHide,
  InformationDiv,
  Line,
  ListSection,
  NameDiv,
  Page,
  // SecondDiv,
  ThirdDiv,
  TitleDiv,
  // ValuesDiv,
} from "./styles";
const yearsOptions: string[] = getYearOptions();
const statusOptions: string[] = ["Todas", "Em aberto", "Pago"];

const FacilityCard = ({ facility, onEdit }: { facility: FacilityData; onEdit: () => void }) => (
  <CardRow>
    <CardRowCells>
      <CardRowCell label="INSTALAÇÃO" value={facility.facility_code} icon={<BsHouse />} />
    </CardRowCells>
    <CardRowActions>
      <SimpleButton variant="simple" className="!w-fit" label="Editar" onClick={onEdit} />
    </CardRowActions>
  </CardRow>
);

const ContractCard = ({ contract }: any) => (
  <CardRow className="mt-8">
    <CardRowCells>
      <CardRowCell
        label="NOME"
        value={contract.name}
        icon={<BiFile />}
        renderValue={(value) => <PowerPlantNameDisplay name={String(value)} />}
      />
      <CardRowCell label="DATA" value={contract.date} icon={<BiCalendar />} />
    </CardRowCells>
    <CardRowActions>
      <a href={contract.file_url} target="_blank" rel="noreferrer">
        <SimpleButton variant="simple" label="Baixar" />
      </a>
    </CardRowActions>
  </CardRow>
);

const InternalConsumer = ({
  consumer,
  billsInfo,
  page,
  totalPages,
  contracts,
  openFacilityModal,
  consumerCreatedMessage,
}: any) => {
  const { showAlert } = useContext(AlertContext);
  const [editConsumerModalOpen, setEditConsumerModalOpen] = useState(false);
  const [createFacilityModalOpen, setCreateFacilityModalOpen] = useState(false);
  const [editFacility, setEditFacility] = useState<FacilityData | null>(null);
  const [moreInfo, setMoreInfo] = useState(false);
  //const [billsInfo, setBillsInfo] = useState<any[]>([]);
  const today = new Date();

  const [filters, setFilters] = useState({
    year: String(today.getFullYear()),
    status: "",
  });

  const statusValues = { Todas: null, "Em aberto": "not_paid", Pago: "paid" };

  const changeFilters = ({ year = filters.year, status = filters.status }) => {
    setFilters({ year, status });
    router.reload({
      data: {
        page: 1,
        year: year,
        payment_status: statusValues[status] !== undefined ? statusValues[status] : status,
      },
    });
  };
  const showMore = () => page != totalPages && billsInfo.length != 0;

  useEffect(() => {
    if (!openFacilityModal) return;

    showAlert({ message: consumerCreatedMessage, type: "success" });
    const timer = window.setTimeout(() => setCreateFacilityModalOpen(true), 500);

    return () => window.clearTimeout(timer);
  }, [consumerCreatedMessage, openFacilityModal, showAlert]);

  // useEffect(() => {
  //   if (currentUser?.id) {
  //     Bills.all({
  //       userId: id,
  //       status: filters.status,
  //       year: filters.year,
  //       page: page,
  //     }).then((res) => {
  //       if (res.headers["current-page"] == "1") {
  //         setBillsInfo(res.data);
  //       } else {
  //         setBillsInfo((prevState) => [...prevState, ...res.data]);
  //       }
  //       setTotalPages(res.headers["total-pages"]);
  //     });
  //   }
  // }, [filters, id, page, currentUser]);
  const overdueInformation = OverdueStatus(consumer.overdue_status);

  return (
    <div>
      {editConsumerModalOpen && (
        <CreateConsumerModal
          isOpen
          onClose={() => setEditConsumerModalOpen(false)}
          mode="edit"
          consumer={consumer}
          onError={(message) => showAlert({ message, type: "error" })}
        />
      )}
      <CreateFacilityModal
        isOpen={createFacilityModalOpen}
        consumerId={consumer.id}
        consumerCpf={consumer.cpf}
        onClose={() => setCreateFacilityModalOpen(false)}
        onSaved={(message) => showAlert({ message, type: "success" })}
        onError={(message) => showAlert({ message, type: "error" })}
      />
      <CreateFacilityModal
        isOpen={Boolean(editFacility)}
        consumerId={consumer.id}
        consumerCpf={consumer.cpf}
        mode="edit"
        facility={editFacility || undefined}
        onClose={() => setEditFacility(null)}
        onSaved={(message) => showAlert({ message, type: "success" })}
        onError={(message) => showAlert({ message, type: "error" })}
      />
      <FirstDiv>
        <div className="flex flex-wrap gap-3">
          <ButtonDiv>
            <SimpleButton
              onClick={() => router.get("/manager/consumers")}
              variant="simple"
              label="Voltar para clientes"
            />
          </ButtonDiv>
          <ButtonDiv>
            <SimpleButton
              onClick={() => setEditConsumerModalOpen(true)}
              variant="simple"
              label="Editar cliente"
            />
          </ButtonDiv>
        </div>

        <div className="grid grid-cols-1 justify-between pt-5 md:grid-cols-2">
          <div className="col">
            <NameDiv>
              <AccountTimeDiv>
                <Typography variant="overline" color="white">
                  NOME
                </Typography>
                <Typography variant="h3" color="white">
                  <span className="flex items-center gap-2">
                    {consumer.name}
                    {consumer.active === false && <Pill variant="red" text="Inativo" />}
                  </span>
                </Typography>
              </AccountTimeDiv>
            </NameDiv>
          </div>
          <div className="col">
            <DatesSecondDiv>
              <BreakDiv>
                <Typography variant="overline" color="white">
                  SITUAÇÃO
                </Typography>
                <Typography variant="pLarge" color="white" />
                <div className={overdueInformation.backgroundColor}>
                  <Typography variant="pLarge" color={overdueInformation.color}>
                    {overdueInformation.label}
                  </Typography>
                </div>
              </BreakDiv>
              <BreakDiv>
                <Typography variant="overline" color="white">
                  DATA DE ADESÃO
                </Typography>
                <Typography variant="pLarge" color="white">
                  {monthYearFormat(consumer.created_at)}
                </Typography>
              </BreakDiv>
            </DatesSecondDiv>
          </div>
        </div>
        {moreInfo && (
          <>
            <Line />
            <div>
              <TitleDiv>
                <InfoIconDiv>
                  <AiOutlineThunderbolt size={22} />
                </InfoIconDiv>
                <Typography variant="pLarge" color="white">
                  Responsável
                </Typography>
              </TitleDiv>
              <InformationDiv>
                <InformationBoxHide>
                  <BreakDiv>
                    <Typography variant="pLarge" color="white">
                      CPF OU CNPJ
                    </Typography>
                    <Typography variant="h5" color="white">
                      {consumer.cpf || consumer.cnpj}
                    </Typography>
                  </BreakDiv>
                </InformationBoxHide>
                <InformationBoxHide>
                  <BreakDiv>
                    <Typography variant="pLarge" color="white">
                      E-MAIL
                    </Typography>
                    <Typography variant="h5" color="white">
                      {consumer.email}
                    </Typography>
                  </BreakDiv>
                  <BreakDiv>
                    <Typography variant="pLarge" color="white">
                      Celular
                    </Typography>
                    <Typography variant="h5" color="white">
                      {consumer.phone}
                    </Typography>
                  </BreakDiv>
                </InformationBoxHide>
              </InformationDiv>
            </div>
            <Line />
            <div>
              <TitleDiv>
                <InfoIconDiv>
                  <BsHouse size={22} />
                </InfoIconDiv>
                <Typography variant="pLarge" color="white">
                  Endereço
                </Typography>
              </TitleDiv>
              <InformationDiv>
                <BreakDiv>
                  <Typography variant="pLarge" color="white">
                    CEP
                  </Typography>
                  <Typography variant="h5" color="white">
                    {consumer.address.cep}
                  </Typography>
                </BreakDiv>
                <InformationBoxHide>
                  <BreakDiv>
                    <Typography variant="pLarge" color="white">
                      ENDEREÇO
                    </Typography>
                    <Typography variant="h5" color="white">
                      {consumer.address.address}
                    </Typography>
                  </BreakDiv>
                </InformationBoxHide>
                <InformationBoxHide>
                  <BreakDiv>
                    <Typography variant="pLarge" color="white">
                      NÚMERO
                    </Typography>
                    <Typography variant="h5" color="white">
                      {consumer.address.number}
                    </Typography>
                  </BreakDiv>
                  <BreakDiv>
                    <Typography variant="pLarge" color="white">
                      COMPLEMENTO
                    </Typography>
                    <Typography variant="h5" color="white">
                      {consumer.address.complement}
                    </Typography>
                  </BreakDiv>
                </InformationBoxHide>
                <InformationBoxHide>
                  <BreakDiv>
                    <Typography variant="pLarge" color="white">
                      BAIRRO
                    </Typography>
                    <Typography variant="h5" color="white">
                      {consumer.address.neighborhood}
                    </Typography>
                  </BreakDiv>
                </InformationBoxHide>
                <InformationBoxHide>
                  <BreakDiv>
                    <Typography variant="pLarge" color="white">
                      CIDADE
                    </Typography>
                    <Typography variant="h5" color="white">
                      {consumer.address.city}
                    </Typography>
                  </BreakDiv>
                  <BreakDiv>
                    <Typography variant="pLarge" color="white">
                      ESTADO
                    </Typography>
                    <Typography variant="h5" color="white">
                      {consumer.address.uf}
                    </Typography>
                  </BreakDiv>
                </InformationBoxHide>
              </InformationDiv>
            </div>
            <Line />
            {contracts && (
              <>
                <Typography variant="h4" color="white">
                  Contratos
                </Typography>
                {contracts.map((contract: any, id: number) => (
                  <ContractCard key={id} contract={contract} />
                ))}
              </>
            )}
          </>
        )}
        {!moreInfo ? (
          <CenterDiv>
            <ButtonDiv>
              <SimpleButton
                onClick={() => {
                  setMoreInfo(!moreInfo);
                }}
                backgroundColor="white"
                variant="simple"
                label="Dados Cadastrais +"
              />
            </ButtonDiv>
          </CenterDiv>
        ) : (
          <CenterDiv>
            <ButtonDiv>
              <SimpleButton
                onClick={() => {
                  setMoreInfo(!moreInfo);
                }}
                backgroundColor="white"
                variant="simple"
                label="Exibir menos --"
              />
            </ButtonDiv>
          </CenterDiv>
        )}
      </FirstDiv>
      {/* <SecondDiv>
        <Typography variant="h4" color="black">
          Financeiro
        </Typography>
        <InformationBox>
          <BreakDiv>
            <Typography variant="h6" color="black">
              Gasto mensal (médio)
            </Typography>
            <ValuesDiv>
              <IconDiv>
                <TbWallet size={20} />
              </IconDiv>
              <Typography variant="h3" color="black">
                R$
                <Typography variant="h3" color="white">
                  {" "}
                  {moneyFormatterWithoutCurrency(consumer.expenses_info.average)}
                </Typography>
              </Typography>
            </ValuesDiv>
          </BreakDiv>
          <BreakDiv>
            <Typography variant="h6" color="black">
              Gasto total
            </Typography>
            <ValuesDiv>
              <IconDiv>
                <TbWallet size={20} />
              </IconDiv>
              <Typography variant="h3" color="black">
                R$
                <Typography variant="h3" color="white">
                  {" "}
                  {moneyFormatterWithoutCurrency(consumer.expenses_info.total)}
                </Typography>
              </Typography>
            </ValuesDiv>
          </BreakDiv>
          <BreakDiv>
            <Typography variant="h6" color="black">
              Desconto
            </Typography>
            <ValuesDiv>
              <IconDiv>
                <FaMoneyBillWaveAlt size={20} />
              </IconDiv>
              <Typography variant="h3" color="black">
                <Typography variant="h3" color="white">
                  {(consumer.expenses_info.discount * 100).toFixed(2)}
                </Typography>{" "}
                %
              </Typography>
            </ValuesDiv>
          </BreakDiv>
        </InformationBox>
      </SecondDiv>
      <ThirdDiv>
        <Typography variant="h4" color="black">
          Consumo energético
        </Typography>
        <InformationBox>
          <BreakDiv>
            <Typography variant="h6" color="black">
              Consumo mensal (médio)
            </Typography>
            <ValuesDiv>
              <IconDiv>
                <AiOutlineThunderbolt size={22} />
              </IconDiv>
              <Typography variant="h3" color="white">
                {numberFormatter(consumer.consumption_info.average)}
                <Typography variant="h3" color="black">
                  {" "}
                  kWh
                </Typography>
              </Typography>
            </ValuesDiv>
          </BreakDiv>
          <BreakDiv>
            <Typography variant="h6" color="black">
              Consumo total
            </Typography>
            <ValuesDiv>
              <IconDiv>
                <AiOutlineThunderbolt size={22} />
              </IconDiv>
              <Typography variant="h3" color="white">
                {numberFormatter(consumer.consumption_info.total)}
                <Typography variant="h3" color="black">
                  {" "}
                  kWh
                </Typography>
              </Typography>
            </ValuesDiv>
          </BreakDiv>
        </InformationBox>
      </ThirdDiv> */}
      <ThirdDiv>
        <ListSection className="w-full">
          <Typography variant="h4" color="black">
            Unidades consumidoras ({consumer.facilities.length})
          </Typography>
          <ButtonDiv>
            <SimpleButton
              variant="simple"
              className="!w-fit"
              label="Criar nova UC"
              onClick={() => setCreateFacilityModalOpen(true)}
            />
          </ButtonDiv>
        </ListSection>
        <CenterDiv>
          {consumer.facilities.length === 0 ? (
            <Typography variant="h6" color="black">
              O cliente ainda não possui unidades consumidoras.
            </Typography>
          ) : (
            <HeaderInfo>
              {consumer.facilities.map((item: FacilityData) => (
                <FacilityCard key={item.id} facility={item} onEdit={() => setEditFacility(item)} />
              ))}
            </HeaderInfo>
          )}
        </CenterDiv>
      </ThirdDiv>
      <BillsDiv>
        <ListSection>
          <Typography variant="h4" color="black">
            Contas ({billsInfo.length})
          </Typography>
          <FiltersContainer>
            <Dropdown
              options={yearsOptions}
              onSelect={(value) => {
                changeFilters({ year: value });
              }}
              defaultValue={"Todos"}
            />
            <Dropdown
              options={statusOptions}
              onSelect={(value) => {
                changeFilters({ status: value });
              }}
            />
          </FiltersContainer>
        </ListSection>
        <CenterDiv>
          {billsInfo.length === 0 ? (
            <Typography variant="h6" color="black">
              O cliente ainda não possui contas.
            </Typography>
          ) : (
            <HeaderInfo>
              {billsInfo.map((bill: any, id: number) => (
                <BillsInfo
                  key={id}
                  month={dateReferenceFormat(bill.reference_month)}
                  value={moneyFormatter(bill.distributor_kwh_price)}
                  compensableTariff={moneyFormatter(bill.compensable_tariff_cents)}
                  valueNumber={bill.distributor_kwh_price}
                  kilowatts={numberFormatter(bill.compensated_kwh)}
                  total={moneyFormatter(bill.price)}
                  totalKwh={bill.total_kwh_price}
                  discountPercentage={bill.discount_percentage}
                  status={bill.payment_status === "paid" ? "Pago" : "Em aberto"}
                  subRows={bill.subRows}
                  was_manually_calculated={bill.was_manually_calculated}
                  was_price_modified={bill.was_price_modified}
                />
              ))}
            </HeaderInfo>
          )}
        </CenterDiv>
        {showMore() && (
          <ButtonContainer>
            <SimpleButton
              variant="simple"
              label="+ Carregar mais"
              onClick={() => {
                router.reload({ data: { page: page + 1 } });
              }}
            />
          </ButtonContainer>
        )}
      </BillsDiv>
      <Page>
        <FaqCardComponent variant="questionSection" />
      </Page>
      <Footer />
    </div>
  );
};

export default InternalConsumer;
